// Date and time helpers
export const pad = (n) => String(n).padStart(2, "0");

export const todayISO = () => {
  const d = new Date();
  // Jeśli jest przed 1:00 rano, użyj wczorajszej daty (restauracja zamyka się o 1:00)
  if (d.getHours() < 1) {
    d.setDate(d.getDate() - 1);
  }
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const timeHHMMSS = () => {
  const d = new Date();
  return `${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
};

// Number formatting
export const fmtPLN = (x) => (Number(x) || 0).toFixed(2);
export const round2 = (x) => Math.round((Number(x) || 0) * 100) / 100;

// Waiter helpers
export const waiterFullName = (w) => `${w.firstName} ${w.lastName}`.trim();

// Split tip amount based on location
export const splitAmount = (amount, location = 'nowysacz') => {
  const a = Number(amount || 0);
  
  if (location === 'krakow') {
    // Kraków: 60% kelner, 30% kuchnia, 10% bar
    const waiterAmount = round2(a * 0.60);
    const kitchenAmount = round2(a * 0.30);
    const barAmount = round2(a * 0.10);
    const diff = round2(a - (waiterAmount + kitchenAmount + barAmount));
    return { 
      amount: round2(a), 
      waiter: round2(waiterAmount + diff), 
      kitchen: kitchenAmount,
      bar: barAmount
    };
  } else {
    // Nowy Sącz: 60% kelner, 40% kuchnia (default)
    const waiterAmount = round2(a * 0.60);
    const kitchenAmount = round2(a * 0.40);
    const diff = round2(a - (waiterAmount + kitchenAmount));
    return { 
      amount: round2(a), 
      waiter: round2(waiterAmount + diff), 
      kitchen: kitchenAmount,
      bar: 0
    };
  }
};

// Welcome toast — wprowadzony rozdzielnie żeby zabezpieczyć username przed XSS
export const showWelcomeToast = (username) => {
  const toast = document.createElement("div");
  toast.className = "welcome-toast";

  const inner = document.createElement("div");
  inner.className = "welcome-toast-content";

  const icon = document.createElement("span");
  icon.className = "welcome-toast-icon";
  icon.textContent = "👋";

  const textWrap = document.createElement("span");
  textWrap.className = "welcome-toast-text";
  // "Witaj, X!" — wstawiamy username przez textContent na <strong>
  textWrap.append("Witaj, ");
  const strong = document.createElement("strong");
  strong.textContent = String(username ?? "");
  textWrap.append(strong, "!");

  inner.append(icon, textWrap);
  toast.append(inner);
  document.body.appendChild(toast);

  setTimeout(() => toast.classList.add("show"), 100);

  setTimeout(() => {
    toast.classList.remove("show");
    setTimeout(() => document.body.removeChild(toast), 300);
  }, 3000);
};
